module.exports = __webpack_public_path__ + "img/info-icon.acca2a22.svg";